import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import {
  Modal,
  HeadingDisplay,
  HelperViewStatus,
  ContentDisplay,
  ListDisplay,
  Heading
} from '@warrenbrasil/nebraska-web';
import { ContentDisplayLoader } from '@/modules/trade/components/ContentDisplayLoader';
import { ListDisplayLoader } from '@/modules/trade/components/ListDisplayLoader';

import { Portal } from '@/modules/common/components/Portal';
import {
  StockProfitDetail,
  getStockProfitDetail
} from '@/modules/wealth/services/portfolio';

interface Props {
  portfolioId: string;
  ticker: string;
  year: string;
  month: string;
  isOpen: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StockProfitModal',
  props: {
    portfolioId: null,
    ticker: null,
    year: null,
    month: null,
    isOpen: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
  ticker: string;
  year: string;
  month: string;
  isOpen: boolean;
}



const isLoading = ref(true);
const hasError = ref(false);
const stockProfitData = ref<StockProfitDetail | null>(null);

const stockProfitDetail = computed(() => {
  return [
    {
      label: 'Mês',
      value: stockProfitData.value?.monthly
    },
    {
      label: '12M',
      value: stockProfitData.value?.past12Months
    },
    {
      label: 'Do início',
      value: stockProfitData.value?.inception
    }
  ];
});

const getStockProfitData = async () => {
  isLoading.value = true;
  hasError.value = false;

  try {
    stockProfitData.value = await getStockProfitDetail(
      props.portfolioId,
      props.ticker,
      props.year,
      props.month
    );
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

watch(
  () => props.isOpen,
  async () => {
    if (props.isOpen) {
      await getStockProfitData();
    }
  },
  { immediate: true }
);

return { __sfc: true,props, isLoading, hasError, stockProfitData, stockProfitDetail, getStockProfitData, Modal, HeadingDisplay, HelperViewStatus, ContentDisplay, ListDisplay, Heading, ContentDisplayLoader, ListDisplayLoader, Portal }
}

})